// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bwPerson[data-v-66cf565a]{cursor:default;font-weight:400;padding:15px 0;-webkit-user-select:none;-moz-user-select:none;user-select:none}.bwPerson-name[data-v-66cf565a]{display:flex;flex-direction:row;font-weight:400;justify-content:space-between;line-height:20px}.bwPerson-personal[data-v-66cf565a]{max-width:200px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
